import styled from 'styled-components';
import { Table } from 'antd';

import { ArrowSlimIcon } from '@/assets/icons/v2';

const ROW_SEPARATOR_COLOR = '#F0F2F5';
const HEADER_SEPARATOR_HEIGHT = '1.75rem';

interface PaginationArrowProps {
	$direction: 'previous' | 'next';
}

export const ActivitiesTable: typeof Table = styled(Table)`
	.ant-table {
		background: transparent;
	}

	.ant-table-container {
		overflow: hidden;
		border-radius: 1rem;
	}

	.ant-table-thead > tr > th {
		position: relative;
		padding: 1.4375rem 1rem;
		background: ${({ theme }) => theme.palette.primary[600]};
		border-bottom: none;
		color: ${({ theme }) => theme.palette.secondary.white};
		font-size: 1rem;
		font-weight: 600;
		line-height: 1.5rem;
		text-align: center;

		&::before {
			display: none;
		}
	}

	.ant-table-thead > tr > th + th::after {
		content: '';
		position: absolute;
		top: 50%;
		left: 0;
		width: 2px;
		height: ${HEADER_SEPARATOR_HEIGHT};
		background: ${({ theme }) => theme.palette.secondary.white};
		transform: translateY(-50%);
	}

	.ant-table-tbody > tr > td {
		height: 4.375rem;
		padding: 1.4375rem 1rem;
		background: ${({ theme }) => theme.palette.secondary[50]};
		border-bottom: 2px solid ${ROW_SEPARATOR_COLOR};
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: 1rem;
		line-height: 1.5rem;
		text-align: center;
	}

	.ant-table-tbody > tr:last-child > td {
		border-bottom: none;
	}

	.ant-table-tbody > tr.ant-table-row:hover > td {
		background: ${({ theme }) => theme.palette.secondary[50]};
	}

	.ant-pagination {
		display: flex;
		align-items: center;
		margin: 1rem 0 0;
	}

	.ant-pagination-total-text {
		flex: 1;
		height: auto;
		margin: 0;
		color: ${({ theme }) => theme.palette.secondary[300]};
		font-size: 0.875rem;
		line-height: 1rem;
	}

	.ant-pagination-item,
	.ant-pagination-prev,
	.ant-pagination-next {
		min-width: 2rem;
		height: 2rem;
		margin: 0 0.125rem;
		line-height: 2rem;
		border: none;
		border-radius: 0.25rem;
	}

	.ant-pagination-item {
		background: ${({ theme }) => theme.palette.secondary[100]};

		a {
			color: ${({ theme }) => theme.palette.secondary[250]};
			font-size: 0.875rem;
			font-weight: 600;
		}
	}

	.ant-pagination-item-active {
		background: ${({ theme }) => theme.palette.primary[100]};

		a {
			color: ${({ theme }) => theme.palette.primary.default};
		}
	}
`;

export const FileName = styled.span`
	color: ${({ theme }) => theme.palette.secondary[250]};
`;

export const FileLink = styled.button`
	padding: 0;
	background: none;
	border: none;
	color: ${({ theme }) => theme.palette.secondary[400]};
	text-decoration: underline;
	cursor: pointer;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}

	&:hover:enabled {
		color: ${({ theme }) => theme.palette.primary[600]};
		text-decoration: underline;
	}
`;

export const FileError = styled.span`
	color: ${({ theme }) => theme.palette.secondary[250]};
	font-size: 0.75rem;
	line-height: 1rem;
`;

export const ModalTitle = styled.h3`
	margin: 0 0 1.5rem;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.5rem;
	font-weight: 600;
	line-height: 2rem;
`;

export const VideoBox = styled.div`
	overflow: hidden;
	border-radius: 0.5rem;
`;

export const PaginationArrow = styled(ArrowSlimIcon)<PaginationArrowProps>`
	display: block;
	width: 1rem;
	height: 1rem;
	margin: 0.5rem auto;
	color: ${({ theme }) => theme.palette.secondary[150]};
	transform: rotate(${({ $direction }) => ($direction === 'previous' ? '90deg' : '-90deg')});
`;
